import { render, staticRenderFns } from "./ClientNotesTable.vue?vue&type=template&id=7c61d990&"
import script from "./ClientNotesTable.vue?vue&type=script&lang=js&"
export * from "./ClientNotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports